import type { ColorToken } from '@/styles/tokens'

export type LauncherCardVariant = 'blue' | 'green' | 'teal' | 'indigo' | 'magenta' | 'orange' | 'off'

// Shared by `LauncherCard.tsx` and `Sidebar.tsx` (W175, which needs it for its own group icons —
// `NavGroup.accent` is this same variant set). Split into its own module rather than exported from
// `LauncherCard.tsx` itself: a component file exporting a non-component value breaks React Fast
// Refresh (`react-refresh/only-export-components`).
export const VARIANT_COLOR: Record<LauncherCardVariant, ColorToken> = {
  blue: 'blue',
  green: 'green',
  teal: 'teal',
  indigo: 'indigo',
  magenta: 'magenta',
  orange: 'orange',
  off: 'slate',
}

// Tailwind's content scanner needs a literal class string per variant — a template-literal
// `border-t-${color}` is invisible to it and silently produces no border colour at all.
export const VARIANT_BORDER_CLASS: Record<LauncherCardVariant, string> = {
  blue: 'border-t-blue',
  green: 'border-t-green',
  teal: 'border-t-teal',
  indigo: 'border-t-indigo',
  magenta: 'border-t-magenta',
  orange: 'border-t-orange',
  off: 'border-t-slate',
}
